import { COMMON_ENDPOINTS } from "./commonEndpoints";
import { axiosInstance } from "../../apilist/apiInstance";

/**
 * Fetches the address details based on the provided pincode.
 *
 * @param {Object} params - The parameters for the API request.
 * @param {string} params.pincode - The pincode to look up the address for.
 *
 * @returns {Promise} A promise that resolves with the API response data.
 */
export const fetchAddressByPincode = (params) => {
	return axiosInstance.get(COMMON_ENDPOINTS.GET_LOCATION_FROM_PINCODE, {
		params,
	});
};
